import { useCallback, useState } from "react";

export function useStateWithPreservation(initialState) {
  const [state, setRealState] = useState(initialState)

  const setState = useCallback((action) => {
    if (typeof action === 'function') return setState(action(state))

    if (state !== action) setRealState(action)
  }, [state])

  return [state, setState, setRealState]
}
